export const isDevEnv = process.env.NODE_ENV === "development";
